/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_Delete_ConfirmInputs */



/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Manual_Meeting_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_delete_confirm = /** @type {((inputs?: Manual_Meeting_Delete_ConfirmInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_Delete_ConfirmInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verwijderen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer")
	return /** @type {LocalizedString} */ ("Delete")
});